import React, { useState } from 'react';
import { Box, Icon, Link, Table, Text } from '@nimbus-ds/components';
import { ChevronDownIcon, ChevronUpIcon } from '@nimbus-ds/icons';
import { useStoreInfo } from 'commons/hooks';
import { WithdrawObjectInterface } from 'commons/types';
import { WithdrawStatus } from 'commons/types/WithdrawStatusType';
import {
  bankAccountIsUnknown,
  formatCurrency,
  formatDate,
  useTranslationWithPrefix,
} from 'commons/utils';
import StatusTag from '../StatusTag';
import { WithdrawalReportButton } from '../WithdrawalReportButton';
import WithdrawDetails from '../WithdrawDetails';

interface WithdrawsTableRowsInterface {
  withdraw: WithdrawObjectInterface;
  showReportsColumn?: boolean;
}

export default function WithdrawsTableRow({
  withdraw,
  showReportsColumn = false,
}: WithdrawsTableRowsInterface): JSX.Element {
  const { t } = useTranslationWithPrefix('withdraws.withdrawsTable');
  const { storeInfo } = useStoreInfo();
  const [showBank, setShowBank] = useState(false);
  const toggleShowBank = () => setShowBank((prev) => !prev);

  return (
    <>
      <Table.Row id={`${withdraw.id}`}>
        <Table.Cell>
          {bankAccountIsUnknown(withdraw.bankAccount) ? (
            <Text>#{withdraw.withdrawNumber}</Text>
          ) : (
            <Link fontSize="base" appearance="primary" onClick={toggleShowBank}>
              #{withdraw.withdrawNumber}
              <Icon
                color="currentColor"
                source={showBank ? <ChevronUpIcon /> : <ChevronDownIcon />}
              />
            </Link>
          )}
        </Table.Cell>
        <Table.Cell>
          <Text>{formatDate(storeInfo, withdraw.requestedAt)}</Text>
        </Table.Cell>
        <Table.Cell>
          {bankAccountIsUnknown(withdraw.bankAccount) ? (
            <Text>{t('noInformation')}</Text>
          ) : (
            <Text>{withdraw.bankAccount.holderName}</Text>
          )}
        </Table.Cell>
        <Table.Cell>
          <Text>{`${formatCurrency(withdraw.amount, storeInfo)}`}</Text>
        </Table.Cell>
        <Table.Cell>
          <StatusTag tagKey="5" statusType={withdraw.status} />
        </Table.Cell>
        {showReportsColumn && (
          <Table.Cell>
            <WithdrawalReportButton
              withdrawalId={withdraw.id}
              isApproved={withdraw.status === WithdrawStatus.Success}
            />
          </Table.Cell>
        )}
      </Table.Row>
      {showBank && (
        <Table.Row>
          {/* TODO: fix with nimbus and change td by Table.Cell */}
          <td colSpan={showReportsColumn ? 6 : 5}>
            <Box padding="2" backgroundColor="neutral-surface">
              <WithdrawDetails
                accountNumber={withdraw.bankAccount.accountNumber}
                bankName={withdraw.bankAccount.bankName}
                statusCode={withdraw.statusCode}
              />
            </Box>
          </td>
        </Table.Row>
      )}
    </>
  );
}
